import { WEBUILogs } from "../logging";

export default function(locale = "en-US", referenceDate, length = "long") {
    if (!referenceDate || referenceDate.constructor !== Date) {
        WEBUILogs.error("getLocaleMonth: bad referenceDate: " + referenceDate);
    } else {
        let date = new Date(referenceDate);
        return date.toLocaleDateString(locale, { month: length });
    }
}
